import { useEffect, useState } from 'react';
import { createMachine } from 'xstate';
import { useGetDataQuiz } from './useGetDataQuiz'

export const useQuizMachine = (quizName: string, id?:string, userId?: string) => {
    const { data } = useGetDataQuiz(quizName, id, userId)
    const [quizMachine, setQuizMachine] = useState<any>()
    
    useEffect(() => {
        if (data) {      
            setQuizMachine(createQuizMachine(data))
        }
    }, [data])

    const getInitialState = (xstateData: any) => {
        let initstate 
        Object.keys(xstateData).forEach(element => {
            if(xstateData[element].meta.type == 'inputBox') {
                initstate = element
            }
        })
        return initstate
    }

    const createQuizMachine = (xstateData: any) => {
        return createMachine({
            id: `${quizName}Machine`,
            initial: getInitialState(xstateData),
            context: {
            },
            states: {
                ...xstateData
            },
        });
    }
    return {
        ...quizMachine, machine: quizMachine
    }
}

